import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { CheckboxControl } from '../../../models/controls/checkbox-control';
import { OrderService } from '../../../services/order/order.service';
import { IconService, ThemeType } from '@ant-design/icons-angular';
import {
  CheckCircleFill,
  CheckCircleOutline,
} from '@ant-design/icons-angular/icons';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

const ThemeFilled = 'fill';
const ThemeOutlined = 'outline';

@Component({
  selector: 'app-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['./checkbox-control.component.scss'],
})
export class CheckboxControlComponent
  extends BaseControlComponent<CheckboxControl>
  implements OnInit, AfterViewInit, OnDestroy {
  theme: ThemeType = 'outline';

  @ViewChild('checkbox')
  checkbox?: ElementRef;

  private valueListener?: Subscription;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly iconService: IconService,
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
    this.control = new CheckboxControl('', '');
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.iconService.addIcon(CheckCircleOutline);
    this.iconService.addIcon(CheckCircleFill);
    this.theme = this.control.value ? ThemeFilled : ThemeOutlined;
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.valueListener = this.ngModel?.control.valueChanges?.subscribe(
      (value) => {
        this.theme = value ? ThemeFilled : ThemeOutlined;
      }
    );
  }

  ngOnDestroy(): void {
    this.valueListener?.unsubscribe();
  }

  toggle(): void {
    const input: HTMLInputElement = this.checkbox?.nativeElement;
    input.checked = !input.checked;
    input.dispatchEvent(new Event('change'));
  }
  protected onControlChange(): void {
    this.ngModel?.reset(false);
    super.onControlChange();
  }
}
